import React, { useState } from 'react';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CreationErrorsModal from '../../../NewIntervention/Steps/TechnicianAssign/CreationErrorsModal';
import { BatchReport } from './assignment';

type TransitionReportBannerProps = {
  report: BatchReport;
  /** Phrase de succès déjà traduite : elle diffère selon le lot (envoi, renvoi, affectation). */
  successMessage: string;
  onDismiss: () => void;
};

/**
 * Bilan d'un lot — envoi, renvoi ou affectation — affiché au-dessus de la liste plutôt
 * qu'en modale : il reste lisible pendant que l'utilisateur regarde la liste rafraîchie,
 * ce qui est précisément ce qui rend le lien vers les erreurs utile.
 */
export default function TransitionReportBanner({
  report,
  successMessage,
  onDismiss
}: TransitionReportBannerProps) {
  const { t } = useTranslation();
  const [errorsOpen, setErrorsOpen] = useState(false);

  const hasFailures = report.failures.length > 0;

  return (
    <>
      <Alert
        severity={report.failedCount > 0 ? 'warning' : 'success'}
        closeText={t('close')}
        onClose={onDismiss}
      >
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Typography variant="body2">{successMessage}</Typography>
          {report.failedCount > 0 && (
            <Typography variant="body2">
              {t('interventionCreation.assignment.report.failed', { count: report.failedCount })}
            </Typography>
          )}
          {hasFailures && (
            <Link component="button" type="button" onClick={() => setErrorsOpen(true)}>
              {t('interventionCreation.assignment.report.seeErrors', {
                total: report.failures.length
              })}
            </Link>
          )}
        </Stack>
      </Alert>

      {/* Table d'erreurs de la v1, réutilisée telle quelle : elle liste le point de
          service et le motif du refus, ligne par ligne. */}
      <CreationErrorsModal
        open={errorsOpen}
        invalidData={report.failures}
        onClose={() => setErrorsOpen(false)}
      />
    </>
  );
}
